// extracted by mini-css-extract-plugin
export default {"main":"SubCategory_main__2l0-r","active":"SubCategory_active__6vmfz"};